import { createLoader } from '@meteor/data-hooks';
import { fetchUserSpecial, withAuth } from '../auth/withAuth';
import { userClient } from '../client';

export let userLoader = createLoader({
  name: 'user',
  fetch: () => fetchUserSpecial(),
  mutators: {
    update: (i: {
      firstName?: string;
      lastName?: string;
      name?: string;
      imageFileId?: string | null;
    }) => withAuth(() => userClient.user.update(i))

    // delete: (i: {
    //   firstName?: string;
    //   lastName?: string;
    //   name?: string;
    //   imageFileId?: string | null;
    // }) => withAuth(() => userClient.user.delete(i))
  }
});

export let firstUserLoad = userLoader.fetchAndReturn();

export let useUser = () => {
  let user = userLoader.use();

  return {
    ...user,

    updateMutator: user.useMutator('update')

    // deleteMutator: user.useMutator('delete')
  };
};
